import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { readAccessToken } from '$/services/accessToken';

export const fetcher = async <T>(
  url: string,
  {
    parser,
    signal,
    body,
    method,
    includeCredentials = false,
  }: {
    parser: (data: unknown) => T;
    signal?: AbortSignal;
    body?: RequestInit['body'] | object;
    method: RequestInit['method'];
    includeCredentials?: boolean;
  },
): Promise<{ isSuccessful: boolean; httpStatusCode: number; response: T }> => {
  const accessToken = readAccessToken();
  const headers = new Headers();

  const language = useLocalizationStore.getState().language;

  if (language) {
    headers.append('Accept-Language', language);
  }

  if (includeCredentials) {
    headers.append('Authorization', `Bearer ${accessToken}`);
  }

  const isFormData = body instanceof FormData;

  if (
    (method === 'POST' || method === 'PUT' || method === 'PATCH') &&
    !isFormData
  ) {
    headers.append('Content-Type', 'application/json');
  }

  const shouldStringify = typeof body === 'object' && !isFormData;

  const response = await fetch(url, {
    signal,
    body: shouldStringify ? JSON.stringify(body) : (body as BodyInit),
    method,
    headers,
    credentials: includeCredentials ? 'include' : 'omit',
  });

  try {
    return {
      isSuccessful: response.status < 400,
      httpStatusCode: response.status,
      response: parser(await response.json()),
    };
  } catch (e) {
    if (!signal?.aborted) console.error([e, response.body]);
    throw new Error(JSON.stringify(e));
  }
};
